import {
  Button,
  HStack,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Popover,
  PopoverTrigger,
  Portal,
  Text,
  Tooltip,
  useDisclosure,
  VStack,
} from '@chakra-ui/react';
import FrameInspectSharpIcon from '@gamma/ui/icons/FrameInspectSharpIcon';
import KeyboardArrowDownSharpIcon from '@gamma/ui/icons/KeyboardArrowDownSharpIcon';
import OpenInNewSharpIcon from '@gamma/ui/icons/OpenInNewSharpIcon';
import { RouterLink } from '@gamma/ui/navigation';
import { ROUTES } from '../../../../../../../../../../../../shared/constants';
import { i18n } from '../../../../../../../../../../../../shared/localization';

const { buttons } = i18n.pages.entityDetails;
const { logscaleDetails } = i18n.pages.detections;
const { logSearch } = ROUTES;

interface LogscaleMenuButtonProps {
  searchQueryString: string;
  investigateModalOnOpen?: () => void;
  showContent?: boolean;
  isLoading?: boolean;
}

export const LogscaleMenuButton = ({
  searchQueryString,
  investigateModalOnOpen,
  showContent,
  isLoading = false,
}: LogscaleMenuButtonProps) => {
  const { isOpen, onClose } = useDisclosure();
  return (
    <Popover
      isOpen={isOpen}
      offset={[0, 10]}
      onClose={onClose}
      placement="bottom-start"
    >
      <Menu>
        <PopoverTrigger>
          <span>
            <Tooltip
              label={buttons.investigateLogs}
              placement="bottom-end"
              isDisabled={showContent}
            >
              <MenuButton
                as={Button}
                variant="solid"
                colorScheme="gray"
                rightIcon={
                  showContent ? <KeyboardArrowDownSharpIcon /> : undefined
                }
                onClick={(e) => {
                  e.stopPropagation();
                }}
                aria-label={buttons.investigateLogs}
                data-testid="investigate-button"
              >
                <HStack>
                  <FrameInspectSharpIcon />
                  {showContent && (
                    <Text fontSize="small">{buttons.investigateLogs}</Text>
                  )}
                </HStack>
              </MenuButton>
            </Tooltip>
          </span>
        </PopoverTrigger>
        <Portal>
          <MenuList zIndex="popover">
            <VStack spacing={0} alignItems="start">
              {investigateModalOnOpen && (
                <MenuItem
                  data-testid="view-related-logs"
                  onClick={(e) => {
                    e.stopPropagation();
                    investigateModalOnOpen();
                  }}
                  isDisabled={isLoading}
                >
                  {logscaleDetails.viewLogs}
                </MenuItem>
              )}
              <MenuItem
                data-testid="view-in-log-search"
                as={RouterLink}
                to={`${logSearch}${searchQueryString}`}
                target="_blank"
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                <Text>{logscaleDetails.viewLogSearch}</Text>
                <IconButton
                  isLoading={isLoading}
                  size="box-sm"
                  icon={<OpenInNewSharpIcon />}
                  aria-label={logscaleDetails.viewLogSearch}
                />
              </MenuItem>
            </VStack>
          </MenuList>
        </Portal>
      </Menu>
    </Popover>
  );
};
